<!--
单页面示例：字段较多、两列布局；
-->
<template>
  <scroll-right-frame class="demo-spage-2">
    <div class="rp-wrapper">
      <div class="rp-header">
        <span class="rp-header-title">主讲教师信息</span>
      </div>
      <div class="rp-body">
        <div class="rp-form">
          <el-form ref="form" :model="formData" label-width="80px" :size="formSize">
            <div style="width: 48%; float: left;">
              <el-form-item label="用户名">
                <el-input v-model="formData.loginId"></el-input>
              </el-form-item>
              <el-form-item label="姓名">
                <el-input v-model="formData.trueName"></el-input>
              </el-form-item>
              <el-form-item label="性别">
                <el-radio-group v-model="formData.gender">
                  <el-radio :label="1" border>男</el-radio>
                  <el-radio :label="2" border>女</el-radio>
                  <el-radio :label="3" border>其他</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="生日">
                <el-date-picker type="date" v-model="formData.birthdate" style="width: 100%;"></el-date-picker>
              </el-form-item>
              <el-form-item label="密码">
                <el-input v-model="formData.password" type="password"></el-input>
              </el-form-item>
              <el-form-item label="确认密码">
                <el-input v-model="formData.password" type="password2"></el-input>
              </el-form-item>
              <el-form-item label="姓名拼音">
                <el-input v-model="formData.pinyin"></el-input>
              </el-form-item>
              <el-form-item label="身份证号">
                <el-input v-model="formData.idNumber"></el-input>
              </el-form-item>
              <el-form-item label="联系电话">
                <el-input v-model="formData.phone"></el-input>
              </el-form-item>
              <el-form-item label="工作单位">
                <el-input v-model="formData.workUnit"></el-input>
              </el-form-item>
              <el-form-item label="师资来源">
                <el-select v-model="formData.profession" placeholder="请选择" style="width: 100%;">
                  <el-option label="本校" value="1"></el-option>
                  <el-option label="外援" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="职业">
                <el-select v-model="formData.profession" placeholder="请选择" style="width: 100%;">
                  <el-option label="教师" value="1"></el-option>
                  <el-option label="其他" value="2"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div style="width: 48%; float: left; margin-left: 20px">
              <el-form-item label="头像">
                <el-upload
                  class="avatar-uploader"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="imageUrl" :src="imageUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="邮编">
                <el-input v-model="formData.zipCode"></el-input>
              </el-form-item>
              <el-form-item label="通讯地址">
                <el-input v-model="formData.address"></el-input>
              </el-form-item>
              <el-form-item label="电子邮箱">
                <el-input v-model="formData.email"></el-input>
              </el-form-item>
              <el-form-item label="博客地址">
                <el-input v-model="formData.blogUrl"></el-input>
              </el-form-item>
              <el-form-item label="职务">
                <el-input v-model="formData.duty"></el-input>
              </el-form-item>
              <el-form-item label="职称">
                <el-select v-model="formData.jobTitle" placeholder="请选择" style="width: 100%;">
                  <el-option label="教授" value="1"></el-option>
                  <el-option label="副教授" value="2"></el-option>
                  <el-option label="讲师" value="2"></el-option>
                  <el-option label="主教" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否博导">
                <el-select v-model="formData.profession" placeholder="请选择" style="width: 100%;">
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="2"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div style="clear: both;"></div>
            <el-form-item label="简介">
              <el-input v-model="formData.intro" type="textarea" :rows="3"></el-input>
            </el-form-item>
            <el-form-item size="large" style="text-align: center;">
              <button class="btn btn-solid">确定</button>
              <button class="btn btn-hollow">取消</button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="rp-footer">
      </div>
    </div>
  </scroll-right-frame>
</template>
<script>
  import ScrollRightFrame from '../../../components/scroll-right-frame'

  export default {
    name: 'demo-spage-2',
    components: {ScrollRightFrame},
    data() {
      return {
        formSize: 'small', // form尺寸
        formData: {},
        imageUrl: ''
      }
    },
    methods: {
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw)
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg'
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!')
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
        }
        return isJPG && isLt2M
      }
    }
  }
</script>
<style lang="scss">
  .demo-spage-2 {
    .el-scrollbar__bar {
      bottom: 16px;
    }
    .rp-wrapper {
      min-width: 1000px;
    }
    .rp-form {
      width: 80%;
    }
    .avatar-uploader .el-upload {
      border: 2px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
    .btn-hollow {
      margin-left: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/custom/components/demo/demo-spage-2.vue